import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units: [],
			count: null
		};
	},
	// props: {
	// 	filter: Object,
	// 	sorting: String,
	// 	max: String
	// },
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section-street');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}
		var beds = 2;
		let el = document.querySelector("[data-beds]");
		if (el) {
			beds = parseInt(el.getAttribute('data-beds'), 10);
		} else {
			console.log('element is not found..................');
		}
		var street;
		let e3 = document.querySelector("[data-street-name]");
		if (e3) {
			street = e3.getAttribute('data-street-name');
		}
		var unitId;
		let e4 = document.querySelector("[data-unit-id]");
		if (e4) {
			unitId = parseInt(e4.getAttribute('data-unit-id'));
		}
		var req;

		if (street) {
			req = {
				fields: this.resultFields,
				filter: {
					'address.street': street
				},
				max: 6,
				sorting: 'random'
			};

		}


		doReq('searchUnits', req)
			.then((res) => {
				var foundUnits = [];
				if (res.units.length) {
					for (let i = 0; i < res.units.length; i++) {
						if (res.units[i]._id !== unitId) {
							foundUnits.push(res.units[i]);
						}

					}
				}
				this.count = foundUnits.length;
				this.units = foundUnits;


			});


	},
	updated: function () {
		this.applySlider();
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
	},
	methods: {
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				return '_self';
			} else {
				return 'unit_' + id;
			}
		},


		applySlider: function () {
			$(".owl-carousel.similar-street").owlCarousel({
				loop: false,
				margin: 30,
				smartSpeed: 3000,
				autoplay: false,
				nav: true,
				responsive: {
					0: {
						items: 1
					},
					768: {
						items: 2
					},
					996: {
						items: 3
					},
					1200: {
						items: 4

					}
				}
			});
		}
	}

};